import React from 'react';
import {
  Edit,
  SimpleForm,
  Toolbar,
  SaveButton,
  BooleanInput,
  Link,
  useRecordContext,
} from 'react-admin';
import { Typography, IconButton } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  titleRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 4,
  },
});

const SettingsTitle = () => {
  const record = useRecordContext();

  if (!record) return <span>Settings</span>;

  return (
    <span>
      { record.organization?.name } Settings (groupId: { record.organization?.midasId })
    </span>
  );
};

const SettingsHeader = () => {
  const record = useRecordContext();
  const classes = useStyles();

  if (!record) return null;

  return (
    <>
      <div className={classes.titleRow}>
        <IconButton
          component={Link}
          to="/season-organization"
          size="small"
          color="primary"
          aria-label="Back to season organizations"
        >
          <ArrowBackIcon fontSize="small" />
        </IconButton>
        <Typography variant="h6">{ record.organization?.name } Settings</Typography>
      </div>
      <Typography variant="body2" color="textSecondary" gutterBottom>
        groupId: { record.organization?.midasId }
      </Typography>
    </>
  );
};

const SettingsToolbar = () => {
  return (
    <Toolbar>
      <SaveButton />
    </Toolbar>
  );
};

export const SeasonOrganizationSettings = () => {
  return (
    <Edit
      title={<SettingsTitle />}
      mutationMode="pessimistic"
      redirect={false}
      actions={false}
      transform={(data: any) => ({ showCharts: data.showCharts })}
    >
      <SimpleForm toolbar={<SettingsToolbar />}>
        <SettingsHeader />
        <BooleanInput label="Show Top Charts" source="showCharts" />
      </SimpleForm>
    </Edit>
  );
};
